import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faClipboardList,
  faUser,
  faSignOutAlt,
  faChevronRight,
  faList,
} from "@fortawesome/free-solid-svg-icons";
import { Package } from "lucide-react";
import ArrowLeft from "./images/ArrowLeft.png";
import MenuFooter from "./Component/MenuFooter";
import Bucket from "./images/Gray_Bucket.png";
import { FaStream } from "react-icons/fa";


const UserDashboard = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [customerData, setCustomerData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const storedUser = sessionStorage.getItem("userData");
    if (storedUser) {
      try {
        setUserData(JSON.parse(storedUser));
      } catch (error) {
        console.error("Error parsing userData from sessionStorage:", error);
      }
    }
  }, []);

  
  useEffect(() => {
    if (userData?._id) {
      getCustomerDetails(userData._id);
    }
  }, [userData]);

  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    navigate("/consumer");
  };

  const getCustomerDetails = async (customerId) => {
    const token = userData?.token || sessionStorage.getItem("token");

    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/get-customer-by-customerId?customer_id=${customerId}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "x-token": token,
          },
        }
      );

      const result = await response.json();

      if (result.success) {
        setCustomerData(result.data);
      } else {
        console.error("Failed to fetch customer:", result.message);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* ✅ Top Header Bar */}
      <div className="sticky top-0 bg-white z-30 border-b border-gray-200 px-2 h-14 flex items-center shadow-sm">
        <button
          onClick={() => navigate("/consumer/projectdetails")}
          className="flex items-center justify-center"
        >
          <img src={ArrowLeft} alt="Back" className="w-12 h-8 object-contain" />
        </button>
        <h2 className="ml-2 text-lg font-semibold text-gray-800"></h2>
      </div>

      {/* ✅ Menu + Logout Section */}
      <div className="flex-1 px-5 mt-5 pb-24 space-y-3">
        {/* 🏠 Home */}
        {/* <div
          onClick={() => navigate("/consumer/Projectdetails")}
          className="flex items-center justify-between bg-white rounded-xl p-4 shadow-sm hover:shadow-md active:scale-[0.98] transition cursor-pointer border border-gray-100"
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
              <FontAwesomeIcon icon={faHome} className="text-gray-600 text-lg" />
            </div>
            <p className="text-gray-800 font-medium">Home</p>
          </div>
          <FontAwesomeIcon icon={faChevronRight} className="text-gray-400 text-sm" />
        </div> */}

        {/* 📋 Material Requirements */}
        <div
          onClick={() => navigate("/consumer/app/materiallist")}
          className="flex items-center justify-between bg-white rounded-xl p-4 shadow-sm hover:shadow-md active:scale-[0.98] transition cursor-pointer border border-gray-100"
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
              <FontAwesomeIcon icon={faList} className="text-gray-600 text-lg" />
            </div>
            <p className="text-gray-800 font-medium">Material Requirements</p>
          </div>
          <FontAwesomeIcon icon={faChevronRight} className="text-gray-400 text-sm" />
        </div>

        {/* 📄 RFQ */}
        <div
          onClick={() => navigate("/consumer/app/rfqlist")}
          className="flex items-center justify-between bg-white rounded-xl p-4 shadow-sm hover:shadow-md active:scale-[0.98] transition cursor-pointer border border-gray-100"
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
              <FontAwesomeIcon icon={faClipboardList} className="text-gray-600 text-lg" />
            </div>
            <p className="text-gray-800 font-medium">RFQs</p>
          </div>
          <FontAwesomeIcon icon={faChevronRight} className="text-gray-400 text-sm" />
        </div>

        {/* 📦 Orders */}
        <div
          onClick={() => navigate("/consumer/orders")}
          className="flex items-center justify-between bg-white rounded-xl p-4 shadow-sm hover:shadow-md active:scale-[0.98] transition cursor-pointer border border-gray-100"
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
              <Package className="text-gray-600 text-lg" />
            </div>
            <p className="text-gray-800 font-medium">Orders</p>
          </div>
          <FontAwesomeIcon icon={faChevronRight} className="text-gray-400 text-sm" />
        </div>

        {/* 🪣 Bucket (using image) */}
        <div
          onClick={() => navigate("/consumer/cartpreview")}
          className="flex items-center justify-between bg-white rounded-xl p-4 shadow-sm hover:shadow-md active:scale-[0.98] transition cursor-pointer border border-gray-100"
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
              <img src={Bucket} alt="Bucket" className="w-8 h-8 object-contain" />
            </div>
            <p className="text-gray-800 font-medium">Bucket</p>
          </div>
          <FontAwesomeIcon icon={faChevronRight} className="text-gray-400 text-sm" />
        </div>

        {/* ⭐ Add to Save List */}
  <div
  onClick={() => navigate("/consumer/savedItems")}
  className="flex items-center justify-between bg-white rounded-xl p-4 shadow-sm hover:shadow-md active:scale-[0.98] transition cursor-pointer border border-gray-100"
>
  <div className="flex items-center gap-3">
    <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
      <FaStream className="text-gray-700 text-xl" />
    </div>
    <p className="text-gray-800 font-medium">Saved List</p>
  </div>
  <FontAwesomeIcon icon={faChevronRight} className="text-gray-400 text-sm" />
</div>


        {/* 👤 Profile */}
        <div
          onClick={() => navigate("/consumer/profileaccount")}
          className="flex items-center justify-between bg-white rounded-xl p-4 shadow-sm hover:shadow-md active:scale-[0.98] transition cursor-pointer border border-gray-100"
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
              <FontAwesomeIcon icon={faUser} className="text-gray-600 text-lg" />
            </div>
            <p className="text-gray-800 font-medium">Profile</p>
          </div>
          <FontAwesomeIcon icon={faChevronRight} className="text-gray-400 text-sm" />
        </div>

        {/* 🚪 Logout */}
        <div className="pt-4 mb-4">
          <button
            onClick={handleLogout}
            className="w-full flex items-center justify-center gap-2 bg-red-500 text-white font-semibold py-3 rounded-xl shadow-md transition"
          >
            <FontAwesomeIcon icon={faSignOutAlt} />
            Logout
          </button>
        </div>
      </div>

      {/* ✅ Footer */}
      <MenuFooter />
    </div>
  );
};

export default UserDashboard;
